var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SingleItem',{attrs:{"singleItem":_vm.singleItem}})}
var staticRenderFns = []

export { render, staticRenderFns }